// *****************************************
// ************* Image Gallery *************
// *****************************************

import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

class ImageGallery {

    constructor(el) {
        this.el = el;
        // show captions in modal?
        this.showCaptions = this.el.dataset.showCaptions == 'true';
        // get items
        this.items = [];
        this.pswp = document.querySelector('.pswp');
        let findItems = this.el.querySelectorAll('figure a');
        if(findItems != null) {
            [...findItems].forEach((itemElement, itemIndex) => {
                // store item details
                let dataWidth = itemElement.dataset.width,
                    dataHeight = itemElement.dataset.height;
                this.items[itemIndex] = {
                    el : itemElement,
                    src: itemElement.getAttribute('href'),
                    w: parseFloat(dataWidth) > 0 ? parseFloat(dataWidth) : 0,
                    h: parseFloat(dataHeight) > 0 ? parseFloat(dataHeight) : 0,
                    title: this.showCaptions ? itemElement.querySelector('figcaption').innerText : null,
                };
                // behaviour
                itemElement.onclick = (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    // create lightbox
                    this.options = {
                        loop: false,
                        index: itemIndex,
                        bgOpacity: 0.95,
                        showHideOpacity: true,
                        preload: [1, 1]
                    }
                    this.lightBox = new PhotoSwipe(this.pswp, PhotoSwipeUI_Default, this.items, this.options);
                    this.lightBox.listen('gettingData', function (index, item) {
                        if (item.w < 1 || item.h < 1) { // unknown size
                            var img = new Image();
                            img.onload = function () { // will get size after load
                                item.w = this.width; // set image width
                                item.h = this.height; // set image height
                                this.lightBox.invalidateCurrItems(); // reinit Items
                                this.lightBox.updateSize(true); // reinit Items
                            }
                            img.src = item.src; // let's download image
                        }
                    });
                    this.lightBox.init();
                }
            });
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ImageGallery(node);
        }
    });
}